import { locationService } from "Apis";
import { ApiLocation, ApiPageType } from "@incendium/api";

export const updateLocation = async (projectId: number, locationId: number, location: ApiLocation) => {
  const res = await locationService.locationServiceUpdateLocation({
    projectId,
    locationId,
    payload: { location },
  });

  return res.result;
};

/**
 * Determines which page types need to be added, removed, or created
 */
export const getPageTypeChanges = (
  originalPageTypes: ApiPageType[],
  newPageTypes: ApiPageType[]
) => {
  const originalIds = originalPageTypes.map(pt => pt.id);
  const newIds = newPageTypes.map(pt => pt.id);

  const toAdd = newPageTypes.filter(pt => pt.id && !originalIds.includes(pt.id));
  const toRemove = originalPageTypes.filter(pt => pt.id && !newIds.includes(pt.id));

  return { toAdd, toRemove };
};

/**
 * Creates a new page type
 */
export const createPageType = async (projectId: number, name: string): Promise<ApiPageType> => {
  const res = await locationService.locationServiceCreatePageType({
    projectId,
    payload: { name },
  });
  return res;
};

/**
 * Appends a page type to a location
 */
export const appendPageTypeToLocation = async (
  projectId: number,
  locationId: number,
  pageTypeId: number
) => {
  await locationService.locationServiceAppendLocationPageType({
    projectId,
    locationId,
    pageTypeId,
  });
};

/**
 * Removes a page type from a location
 */
export const removePageTypeFromLocation = async (
  projectId: number,
  locationId: number,
  pageTypeId: number
) => {
  await locationService.locationServiceRemoveLocationPageType({
    projectId,
    locationId,
    pageTypeId,
  });
};

/**
 * Syncs page types for a location - handles adds and removes
 */
export const syncLocationPageTypes = async (
  projectId: number,
  locationId: number,
  originalPageTypes: ApiPageType[],
  newPageTypes: ApiPageType[]
) => {
  const { toAdd, toRemove } = getPageTypeChanges(originalPageTypes, newPageTypes);

  // Remove page types that are no longer needed
  await Promise.all(
    toRemove.map(pt =>
      removePageTypeFromLocation(projectId, locationId, pt.id as number)
    )
  );

  // Add new page types
  await Promise.all(
    toAdd.map(pt =>
      appendPageTypeToLocation(projectId, locationId, pt.id as number)
    )
  );
};